window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.status_capsule = window.locales.am.status_capsule || {};window.locales.am.status_capsule = {...window.locales.am.status_capsule, ...{
    "creator": "ፈጣሪ",
    "invited": "ተጋብዟል",
    "accepted": "ተቀባይ",
    "declined": "ውድቅ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.status_capsule = window.locales.ar.status_capsule || {};window.locales.ar.status_capsule = {...window.locales.ar.status_capsule, ...{
    "creator": "منشئ",
    "invited": "مدعو",
    "accepted": "مقبول",
    "declined": "مرفوض"
}
};window.locales.en = window.locales.en || {};window.locales.en.status_capsule = window.locales.en.status_capsule || {};window.locales.en.status_capsule = {...window.locales.en.status_capsule, ...{
    "creator": "Creator",
    "invited": "Invited",
    "accepted": "Accepted",
    "declined": "Declined"
}
};window.locales.es = window.locales.es || {};window.locales.es.status_capsule = window.locales.es.status_capsule || {};window.locales.es.status_capsule = {...window.locales.es.status_capsule, ...{
    "creator": "Creador",
    "invited": "Invitado",
    "accepted": "Aceptado",
    "declined": "Rechazado"
}
};window.locales.it = window.locales.it || {};window.locales.it.status_capsule = window.locales.it.status_capsule || {};window.locales.it.status_capsule = {...window.locales.it.status_capsule, ...{
    "creator": "Creatore",
    "invited": "Invitato",
    "accepted": "Accettato",
    "declined": "Rifiutato"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.status_capsule = window.locales.zh.status_capsule || {};window.locales.zh.status_capsule = {...window.locales.zh.status_capsule, ...{
    "creator": "创建者",
    "invited": "受邀",
    "accepted": "已接受",
    "declined": "已拒绝"
}
};